import React, { Fragment } from 'react';

import { CircularProgress } from '@material-ui/core';

import * as S from './styles';

interface Props {
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmClean({
  isLoading = false,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <Fragment>
      <S.Container>
        <S.Title>Limpar chat</S.Title>
        <S.Content>
          <p>
            Essa ação <strong>não poderá ser desfeita</strong>. Deseja limpar
            este chat?
          </p>
        </S.Content>
        <S.Actions>
          <S.ActionButton
            variant="text"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancelar
          </S.ActionButton>
          <S.ActionButton
            className="confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            Limpar
          </S.ActionButton>
        </S.Actions>
      </S.Container>
      <S.Backdrop open={isLoading}>
        <CircularProgress color="inherit" />
      </S.Backdrop>
    </Fragment>
  );
}
